import type { RequestedFile } from 'api';
import type { RequestedFileFulfillmentStatus } from 'common/types/files/files';
import { isRequestedFileFulfilled } from 'common/types/files/files';

// The generated client types fulfillment as an enum (and `is_fulfilled` as a
// string); the app works with the shared string-union form everywhere else.
export type OnboardingRequestedFile = Omit<
  RequestedFile,
  'fulfillment_status' | 'is_fulfilled'
> & {
  fulfillment_status?: RequestedFileFulfillmentStatus;
  fulfillment_note?: string | null;
  is_fulfilled?: boolean;
};

export const toOnboardingRequestedFiles = (
  files: RequestedFile[] | undefined
): OnboardingRequestedFile[] => (files ?? []) as unknown as OnboardingRequestedFile[];

export const isOnboardingDocumentFulfilled = (requestedFile?: OnboardingRequestedFile | null): boolean => {
  if (!requestedFile) {
    return false;
  }
  return isRequestedFileFulfilled({
    is_uploaded: requestedFile.is_uploaded,
    is_fulfilled: requestedFile.is_fulfilled,
    fulfillment_status: requestedFile.fulfillment_status,
    files: requestedFile.files,
  });
};

export const isOnboardingDocumentMarkedNa = (requestedFile?: OnboardingRequestedFile | null): boolean =>
  requestedFile?.fulfillment_status === 'not_applicable'
  || requestedFile?.fulfillment_status === 'not_available';

export const getOnboardingFulfillmentSuffix = (
  fulfillmentStatus?: RequestedFileFulfillmentStatus,
  hasUpload = false
): string => {
  if (fulfillmentStatus === 'not_applicable') {
    return ' (N/A)';
  }
  if (fulfillmentStatus === 'not_available') {
    return ' (not available)';
  }
  if (hasUpload) {
    return ' (uploaded)';
  }
  return '';
};
